
import React from 'react';
import { TeacherHub } from './TeacherHub';
import { TeacherVideo } from '../../types';

interface TeacherOverlayProps {
    onSelectTeacherVideo: (video: TeacherVideo) => void;
    onClose: () => void;
    lang: 'en' | 'fr';
}

export const TeacherOverlay: React.FC<TeacherOverlayProps> = ({ onSelectTeacherVideo, onClose, lang }) => {
    return (
        <div className="fixed inset-0 z-[10000] flex justify-end">
            <div className="absolute inset-0 bg-black/80 backdrop-blur-xl" onClick={onClose}></div>
            
            <div className="relative w-full max-w-4xl bg-[#00100d] border-l border-emerald-500/20 h-full shadow-2xl flex flex-col animate-fade-in-left overflow-hidden">
                {/* HEADER DÉDIÉ PROFESSEUR */}
                <div className="p-8 bg-gradient-to-br from-emerald-950 to-black border-b border-white/5 shrink-0">
                    <div className="flex justify-between items-start mb-6">
                        <div className="space-y-1">
                            <h2 className="text-4xl font-black text-white italic tracking-tighter uppercase leading-none">Espace <br/><span className="text-emerald-500">Pédagogique</span></h2>
                            <p className="text-[10px] text-emerald-500/60 font-black uppercase tracking-[0.4em] mt-2">Suivi & Vidéos de cours</p>
                        </div>
                        <button onClick={onClose} className="w-14 h-14 rounded-full bg-white/5 flex items-center justify-center text-2xl hover:bg-emerald-500 hover:text-black transition-all border border-white/10 shadow-xl">✕</button>
                    </div>
                </div>

                <div className="flex-1 overflow-y-auto p-10 custom-scrollbar bg-black/40">
                    <TeacherHub onSelectVideo={onSelectTeacherVideo} lang={lang} />
                </div>
                
                <div className="p-6 bg-black border-t border-white/5 flex justify-center">
                    <p className="text-[8px] font-black text-emerald-900 uppercase tracking-[0.6em]">Espace sécurisé • Stockage local uniquement</p>
                </div>
            </div>
        </div>
    );
};
